module.exports = __webpack_public_path__ + "static/media/get_insured_carousel_1.c0a34d31.svg";